import { GoAlertFill } from "react-icons/go";
import TaskBadge from "./TaskBadge";
import { formatDate } from "../../../utils";

const TaskListSection = ({
  title,
  titleIcon = <GoAlertFill size={18} />,
  items = [],
  className = "",
}) => {
  return items?.length ? (
    <div
      className={`shadow-sm ${className}`}
      style={{
        border: "1px solid rgba(220,53,69,.2)",
        borderRadius: 12,
        background: "#ffffff",
        padding: 16,
      }}>
      <div className="d-flex align-items-center mb-3" style={{ color: "#dc3545" }}>
        <span className="me-2">{titleIcon}</span>
        <h5 className="mb-0 fw-bold">{title}</h5>
        <span
          className="ms-2 d-inline-flex align-items-center justify-content-center"
          style={{
            width: 28,
            height: 28,
            borderRadius: 999,
            background: "#dc3545",
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
          }}>
          {items?.length ?? 0}
        </span>
      </div>

      <div>
        {items?.map((it, idx) => (
          <div
            key={idx}
            className="mb-3"
            style={{
              background: "#fff7f7",
              borderRadius: 12,
              padding: 16,
              border: "1px solid #ffe0e0",
            }}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="me-3" style={{ minWidth: 96 }}>
                <TaskBadge text={it.priority} variant={it.priority} />
              </div>
              <div className="flex-grow-1">
                <div className="fw-semibold text-dark mb-2" style={{ fontSize: 16 }}>{it?.title ?? ""}</div>
                <div className="text-muted small d-flex flex-wrap gap-4">
                    <span>
                      Assignee: <span className="text-dark">{it?.assignee?.name ?? ""}</span>
                    </span>
                  {it.dueDate && (
                    <span>
                      Due: <span className="text-dark">{formatDate(it?.due_date ?? "")}</span>
                    </span>
                  )}
                </div>
              </div>
                <span
                  className="align-self-start fw-semibold"
                  style={{
                    background: "#f1f3f5",
                    color: "#343a40",
                    padding: "6px 12px",
                    borderRadius: 999,
                    fontSize: 12,
                  }}>
                  {it.t?.TaskStatus?.status_name || ''}
                </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default TaskListSection;